import { Checkbox } from "@material-ui/core";
import Cell from "./cell";
import React from "react";

const DbRow = ({
  deleteAll,
  isDelete,
  rowIndex,
  rowProps,
  item,
  isReadOnly,
  canDelete = true,
  columnData,
  onChange,
  onCheckChange,
  dataRes,
  index,
  columnKey,
  refRes,
  apiTarget,
}) => {
  return (
    <div
      {...rowProps}
      style={{
        ...rowProps.style,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        overflow: "initial",
        backgroundColor:
          index === 0
            ? deleteAll || isDelete
              ? "#c1e4fe"
              : "white"
            : "transparent",
      }}
      className="td"
    >
      {index === 0 && <div style={{ fontSize: "12px" }}>{rowIndex + 1}</div>}
      {/* The delete checkbox only exists for users who may delete (read-only link: hidden) */}
      {index === 0 && canDelete && (
        <Checkbox checked={deleteAll || isDelete} onChange={onCheckChange} />
      )}
      <Cell
        style={{ width: "380px" }}
        refRes={refRes}
        cell={item.value}
        multiline={columnData?.multiline}
        readOnly={isReadOnly}
        type={columnData?.reference ? "reference" : columnData?.type}
        refColumn={columnData?.reference}
        refItems={
          columnData?.reference
            ? dataRes.map((d) => d[columnKey]).filter((d) => d)
            : null
        }
        onCellChange={onChange}
        apiTarget={apiTarget}
        isMultiRef={columnData?.isMultiRef || (columnData?.reference && Array.isArray(item.value))}
      />
    </div>
  );
};

export default DbRow;
